import styled from "styled-components";

const LoginContainer = styled.div`
    // border-top: 1px solid #666;
    margin-top: 30px;
    margin-bottom: 50px;

    .login-inner {
        @media (min-width: 768px) {
            width: 700px;
        }
    }
`;
export default LoginContainer;
